import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchSomDbTableData = createAsyncThunk(
	"somDb/fetchSomDbTableData",
	async ({ selectedViewMode }, { rejectWithValue, extra, getState, dispatch }) => {
		const state = getState();
		const columnsData = state.somDb.columnsData;
		const filterParams = state.somDb.filterParams;
		const withEmptyChars = state.somDb.withEmptyChars;
		const selectedClassifier = state.somDb.selectedClassifier;
		const selectedStatus = state.somDb.selectedStatus;

		try {
			const { data } = await extra.apiSom.getDb({
				body: {
					mode: selectedViewMode,
					filter_columns: columnsData.filter(({ checked }) => checked).map(({ id }) => id),
					filter_params: filterParams,
					with_empty_chars: withEmptyChars,
					classifier_id: selectedClassifier?.id,
					status: selectedStatus.map(({ id }) => id),
				},
			});

			if (!data) {
				throw new Error();
			}

			return data;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);
